export default "__VITE_ASSET__DcXzwT8B__"